import ToolbarsManager from './src/manager.js';
import Toolbar from './src/toolbar';

export default { ToolbarsManager };